// Apply only complete, classroom-scoped server snapshots. Camera lists are partial.
export function applyRobotReconciliation(store, data, initRobot, studentCache) {
  const pendingSnapshot = data && !data.enabled && data.pending && data.snapshotComplete;
  if (!data || (!data.enabled && !pendingSnapshot) ||
      (pendingSnapshot && store._robotReconciliationEnabled) || data.classRoom !== store.classRoomCode ||
      !Number.isSafeInteger(data.revision) || data.revision < (store._robotReconciliationRevision || 0) ||
      !Array.isArray(data.robots) || !Array.isArray(data.studentRobots)) return false;
  const ids = new Set();
  const numbers = new Set();
  const validRobots = data.robots.every((robot) => {
    if (!robot || typeof robot._id !== 'string' || !robot._id || ids.has(robot._id)) return false;
    const validNumber = Number.isSafeInteger(robot.identifier) && robot.identifier >= 0;
    if (!validNumber && !(pendingSnapshot && robot.numberVerified === false)) return false;
    if (!pendingSnapshot && numbers.has(robot.identifier)) return false;
    ids.add(robot._id);
    numbers.add(robot.identifier);
    return true;
  });
  if (!validRobots) return false;
  if (data.studentRobots.some(student => !student || typeof student._id !== 'string' ||
      !Array.isArray(student.robots) || student.robots.some(id => !ids.has(id)))) return false;
  const previousRobots = new Map(Array.from(store.classRoomRobots.entries()).map(([id, robot]) => [id, { _id: id, identifier: robot.identifier }]));
  const next = {};
  data.robots.forEach((robot) => {
    const current = store.classRoomRobots.get(robot._id);
    next[robot._id] = Object.assign(current || initRobot(), robot, { numberVerified: data.enabled ? true : robot.numberVerified });
    if (next[robot._id].numberVerified !== false && Number.isSafeInteger(robot.identifier)) store.classRoomObjects.delete(robot.identifier);
  });
  store.classRoomRobots.replace(next);
  const ownership = new Map(data.studentRobots.map(student => [student._id, student.robots]));
  (store.classRoomStudents || []).forEach((student) => {
    const robots = ownership.get(String(student._id));
    if (robots) student.robots = robots.map(id => store.classRoomRobots.get(id));
  });
  if (studentCache) studentCache.applyRobotReconciliation(data, store.classRoomRobots, previousRobots);
  store._robotReconciliationRevision = data.revision;
  store._robotReconciliationEnabled = Boolean(data.enabled);
  return true;
}
